"use client";

import { Clock, TrendingUp, ShieldCheck, Cloud, ArrowUpRight } from "lucide-react";
import styles from "./CoreValues.module.css";

export default function CoreValues() {
  const values = [
    {
      title: "Save Time",
      description: "Automate daily tasks and focus on your guests.",
      icon: <Clock size={24} />,
    },
    {
      title: "Increase Revenue",
      description: "Direct bookings, upsells and better guest experience.",
      icon: <TrendingUp size={24} />,
    },
    {
      title: "Secure & Reliable",
      description: "Enterprise-grade security and daily backups.",
      icon: <ShieldCheck size={24} />,
    },
    {
      title: "Access Anywhere",
      description: "Cloud based platform accessible anytime.",
      icon: <Cloud size={24} />,
    },
    {
      title: "Scalable",
      description: "Grow your business with ease and flexibility.",
      icon: <ArrowUpRight size={24} />,
    },
  ];

  return (
    <section className={styles.values} id="values">
      <div className={`${styles.container} container`}>
        <div className={styles.grid}>
          {values.map((val, idx) => (
            <div key={idx} className={styles.card}>
              <div className={styles.iconWrapper}>{val.icon}</div>
              <h3 className={styles.title}>{val.title}</h3>
              <p className={styles.description}>{val.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
